<template>
  <button
    class="ui-button"
    :class="[
      `ui-button--${variant}`,
      `ui-button--${size}`,
      { 'is-loading': loading },
    ]"
    v-bind="$attrs"
  >
    <span v-if="loading" class="ui-button__spinner" aria-hidden="true"></span>
    <slot />
  </button>
</template>

<script>
export default {
  name: "UiButton",
  inheritAttrs: true,
  props: {
    variant: { type: String, default: "primary" },
    size: { type: String, default: "md" },
    loading: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.ui-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: 999px;
  border: 1px solid transparent;
  padding: 10px 16px;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease,
    background 0.2s ease, color 0.2s ease;
}

.ui-button--primary {
  background: linear-gradient(120deg, var(--color-accent), rgba(34, 197, 94, 0.9));
  color: #061221;
  box-shadow: 0 12px 22px rgba(15, 23, 42, 0.35);
}

.ui-button--ghost {
  background: transparent;
  border-color: var(--border);
  color: var(--text);
}

.ui-button--subtle {
  background: rgba(148, 163, 184, 0.12);
  border-color: rgba(148, 163, 184, 0.3);
  color: var(--text);
}

.ui-button--danger {
  background: rgba(239, 68, 68, 0.14);
  border-color: rgba(239, 68, 68, 0.4);
  color: var(--color-danger);
}

.ui-button--sm {
  padding: 6px 12px;
  font-size: 13px;
}

.ui-button--md {
  padding: 10px 16px;
  font-size: 14px;
}

.ui-button--lg {
  padding: 12px 20px;
  font-size: 15px;
}

.ui-button:focus-visible {
  outline: 2px solid rgba(56, 189, 248, 0.8);
  outline-offset: 2px;
}

.ui-button:hover {
  transform: translateY(-1px);
}

.ui-button:disabled,
.ui-button.is-loading {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.ui-button__spinner {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border: 2px solid rgba(6, 18, 33, 0.35);
  border-top-color: rgba(6, 18, 33, 0.9);
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
